import { useAppDispatch } from 'app/hooks'
import { CountType } from 'enums'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEffect } from 'react'
import { Dashboard } from 'schemas/DashboardSchema'
import { createInsightCount } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'
import { getMeasureByCountTypeAndAnalysisType } from 'utils/measureUtil'
import { getInsightCategory } from 'utils/viewOptionUtil'
import { WidgetId } from 'features/types'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { transformFilterPublishedDate } from 'utils/insightModal/strategy/utils/dayHours'

import { DayAndHourWidgetsType } from '../../types'

const createSearches = (widgetSetting: DayAndHourWidgetsType, dashboardData: Dashboard) => {
  const {
    selectedTopic,
    precision,
    viewOption,
    countType,
    analysisType,
    timeZoneOption
  } = widgetSetting

  const filter = toFilter(widgetSetting)
  const transformedFilter = transformFilterPublishedDate(filter, widgetSetting)

  const topicIds = [selectedTopic.topicId!]

  const { id: dashboardId, name } = dashboardData
  const measure = getMeasureByCountTypeAndAnalysisType(countType!, analysisType!)
  const insightCountOption = {
    isAuthorBased: countType === CountType.AUTHORS,
    postActivityTimeZone: timeZoneOption
  }

  const searches = []

  const baseResultSearch = createInsightCount(
    dashboardId!,
    name!,
    precision!,
    topicIds,
    transformedFilter,
    measure!,
    getInsightCategory(viewOption!),
    insightCountOption
  )

  searches.push(baseResultSearch)

  return searches
}

const RunSearchEffect = ({
  widgetId,
  children,
  isAudienceQuery = false // * useless in day and hour widget
}: {
  widgetId: WidgetId
  children: React.ReactElement
  isAudienceQuery?: boolean
}) => {
  const widgetSetting = useDashboardWidgetSetting<DayAndHourWidgetsType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const searches = createSearches(widgetSetting, dashboardData!)
    dispatch(
      getWidgetForDashboard({
        searches,
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, isAudienceQuery, refreshTimestamp])

  return children
}

export default RunSearchEffect
